// extracted by mini-css-extract-plugin
export default {"tableCell":"hesburgerEfficiencyBoundaryTable__tableCell___iXNh3"};